import { ComplianceCaseStatus, DocumentRefreshStatusEnum } from "~/graphql/supergraphEnums";

/**
 * Document expiry statuses that are calculated based on document expiration dates.
 * These are distinct from case statuses.
 */
export const DOCUMENT_EXPIRY_STATUSES = [
  DocumentRefreshStatusEnum.Expired,
  DocumentRefreshStatusEnum.ExpiringSoon,
  DocumentRefreshStatusEnum.RequestSent,
  DocumentRefreshStatusEnum.RequestSentOverdue,
  DocumentRefreshStatusEnum.Active,
  DocumentRefreshStatusEnum.NoDocuments,
  DocumentRefreshStatusEnum.NoExpiryDate,
] as const;

/**
 * Maps DocumentRefreshStatusEnum case status values to ComplianceCaseStatus values.
 * The backend sends custom enum values (e.g., "ready_for_review") that need to be
 * mapped to the standard ComplianceCaseStatus enum values (e.g., "ready").
 */
export const DOCUMENT_REFRESH_TO_CASE_STATUS_MAP: Partial<
  Record<DocumentRefreshStatusEnum, ComplianceCaseStatus>
> = {
  [DocumentRefreshStatusEnum.ReadyForReview]: ComplianceCaseStatus.Ready,
  [DocumentRefreshStatusEnum.InReview]: ComplianceCaseStatus.UnderReview,
  [DocumentRefreshStatusEnum.InProgress]: ComplianceCaseStatus.InProgress,
  [DocumentRefreshStatusEnum.PendingReview]: ComplianceCaseStatus.PendingReview,
  [DocumentRefreshStatusEnum.LpRequestInProgress]: ComplianceCaseStatus.NotReady,
};

/**
 * Checks if a given status is a document expiry status (vs a case status).
 */
export const isDocumentExpiryStatus = (status: DocumentRefreshStatusEnum): boolean => {
  return DOCUMENT_EXPIRY_STATUSES.includes(status as (typeof DOCUMENT_EXPIRY_STATUSES)[number]);
};

/**
 * Maps a DocumentRefreshStatusEnum value to a ComplianceCaseStatus value.
 * Returns the mapped status if it exists in the map, otherwise returns the original value.
 */
export const mapDocumentRefreshToCaseStatus = (
  status: DocumentRefreshStatusEnum,
): ComplianceCaseStatus => {
  return (
    DOCUMENT_REFRESH_TO_CASE_STATUS_MAP[status] || (status as unknown as ComplianceCaseStatus)
  );
};
